import { useAppDispatch } from "hooks/hooks";
import React, { useEffect } from "react";
import {
  getAllPartnersBySearchParams,
  setSearchPopoverState
} from "../main.slice";
import { IGetAllPartnersRequestParams } from "Dashboard/scenes/Partners/domain";
import {
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetFocus
} from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesPartners from "../../../styles/popovers.module.scss";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IGetAllPartnersRequestParams>;
  register: UseFormRegister<IGetAllPartnersRequestParams>;
  setFocus: UseFormSetFocus<IGetAllPartnersRequestParams>;
}

const SearchPartnersPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setSearchPopoverState({ isOpen: false }));
  };

  const onSubmit = async (data: IGetAllPartnersRequestParams) => {
    try {
      dispatch(getAllPartnersBySearchParams(data));
      close();
    } catch (err) {
      console.error(err);
    }
  };

  const { register, handleSubmit, setFocus } = props;

  useEffect(() => {
    setFocus("search");
  }, [setFocus]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit(onSubmit)();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`${classesPartners.searchPopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.colDir}`}>
          <input type="text" {...register("search")}
            className={`${classes.fullWidth} ${classes.itemBorder}`}
          />
        </div>
        <div className={classes.gPopoverDisclaimer}>
          * možete uneti više reči tj. kriterijuma pretrage
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchPartnersPopover;
